import { render, staticRenderFns } from "./bookman-navbar.vue?vue&type=template&id=1f8a0be2&"
import script from "./bookman-navbar.vue?vue&type=script&lang=js&"
export * from "./bookman-navbar.vue?vue&type=script&lang=js&"
import style0 from "./bookman-navbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports